import { useRef } from "react";
import { Box, Button } from "@mui/material";
import { MuiHelper } from "@/helpers";
import { colors, sxButton } from "@/theme";
import { SettingsEditForm, SettingsEditFormRef } from "@/components/organisms";

const Settings: React.FC = () => {
  const childRef = useRef<SettingsEditFormRef | null>(null);

  const handleSaveChangesClick = () => {
    childRef?.current?.saveChanges?.();
  };

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: 'center', justifyContent: 'space-between', px: 4, py: 4 }}>
        {MuiHelper.getHeader("Settings")}
        <Box sx={{ justifySelf: "end" }}>
          <Button onClick={() => handleSaveChangesClick()} sx={sxButton}>
            Save Changes
          </Button>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: colors.neutralGrey300 }}>
        <SettingsEditForm ref={childRef} />
      </Box>
    </Box>
  );
};

export default Settings;
